import { Component, inject, Injector } from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { EscapeKeyboardShortcutService } from '../shared/keyboard-shortcuts/escape-keyboard-shortcut.service';
import { isAnnotationOutput } from './dsl/sensor-fusion/sensor-fusion-output.utils';
import { H3mlStore } from './state/h3ml-store';
import { TaskWorkspaceStore } from './state/task-workspace-store';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- not sure why it won't work with on push
@Component({
  selector: 'h3-root-h3ml-container',
  templateUrl: './root-h3ml-container.component.html',
  styleUrls: ['./root-h3ml-container.component.scss'],
  providers: [{ provide: H3mlStore, useExisting: TaskWorkspaceStore }],
  standalone: false,
})
export class RootH3mlContainerComponent extends DirectiveSuperclass {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  constructor(injector: Injector) {
    super(injector);
    if (this.isCVProject()) {
      inject(EscapeKeyboardShortcutService).register();
    }
  }

  private isCVProject() {
    const outputs = this.taskWorkspaceStore.state().project.outputs;
    return outputs.some(isAnnotationOutput);
  }
}
